import { ChartGanttIcon } from './ChartGanttIcon';

/**
 * author: Austin Andrews
 * id A2839B3A-760A-4061-80CA-41B3FA5817E0
 * name chart-gantt
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-gantt.svg
 * tags
 * - Math 
 */
export const ReportGanttIcon = ChartGanttIcon;
export default ReportGanttIcon